/* eslint-disable import/prefer-default-export */
import { useQuery, useMutation } from '@apollo/client';
import * as Schema from '@core_modules/amrewards/services/graphql/schema';

const USING_INTERNAL = true;

const config = (isUsingInternal) => {
    const context = isUsingInternal ? { request: 'internal' } : {};

    return {
        notifyOnNetworkStatusChange: true,
        context,
        fetchPolicy: 'network-only',
    };
};

export const getGuestRewards = (options = {}) => useQuery(Schema.getGuestRewards, {
    ...options,
    ...config(USING_INTERNAL),
});

export const getRewards = (options = {}) => useQuery(Schema.getRewards, {
    ...options,
    ...config(USING_INTERNAL),
});

export const getRewardStatistic = (options = {}) => useQuery(Schema.getRewardStatistic, {
    ...options,
    ...config(USING_INTERNAL),
});

export const getRewardsOfProduct = (options = {}) => useQuery(Schema.getRewardsOfProduct, {
    ...options,
    ...config(USING_INTERNAL),
});

export const getRewardsInformation = (options = {}) => useQuery(Schema.getRewardsInformation, {
    ...options,
    ...config(USING_INTERNAL),
});

export const useRewardPoints = (options = {}) => useMutation(Schema.useRewardPoints, {
    ...options,
    ...config(USING_INTERNAL),
});

export const saveNotificationOptions = (options = {}) => useMutation(Schema.saveNotificationOptions, {
    ...options,
    ...config(USING_INTERNAL),
});

export const getCustomerNotificationOptions = (options = {}) => useQuery(Schema.getCustomerNotificationOptions, {
    ...options,
    ...config(USING_INTERNAL),
});

export default {
    getGuestRewards,
    getRewards,
    getRewardsInformation,
    getRewardStatistic,
    getRewardsOfProduct,
    useRewardPoints,
    saveNotificationOptions,
    getCustomerNotificationOptions,
};
